import React, { useContext, useEffect, useState } from 'react';
import {auth, logout} from '../firebase/firebase';
import firebase from '../firebase/firebase';
import { Routes, Route, Outlet,  useNavigate, Navigate, useLocation } from 'react-router-dom'
import logo from "../logo.svg";
import {Button} from "@mui/material";
import JoinUs from "../views/auth/onboarding/onboarding-step-2";
import WhoAreYou from "../views/auth/WhoAreYou";
import {AuthUserContext} from "../providers/AuthProvider";
import Spinner from "../components/spinner";
import Login from "../views/auth/login";
import AdditionalDetailsComponent from "../views/auth/onboarding/onboarding-step-3";
import AboutYourWorkComponent from "../views/auth/onboarding/onboarding-step-4";
import TopBar from "../components/TopBarV2";
import SelectYourLocation from "../views/auth/SelectYourLocation"
import ForgotYourPasswordStep1 from "../views/auth/forgotyourpassword/step1";
import AdminRoutes from "./admin-routes";
import ArtistRoutes from "./artist-routes";
import InvestorRoutes from "./investor-routes";
import CreatorRoutes from "./creator-routes";
import Support from '../components/support';
import Alert from "@mui/material/Alert/Alert";

import Footer  from '../components/Footer';
import Privacy from '../components/Privacy';
import Terms from '../components/Terms';
import Cookies from '../components/Cookies';
import Contact from '../components/Contact';
import Portal from "@mui/material/Portal";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import ForgotYourPasswordStep2 from '../views/auth/forgotyourpassword/step2';
import ResetPassword from "../views/common/reset-password";


export default function AppRoutes() {
  const [open, setOpen] = React.useState(false)
  const { user, setUser, profile, setProfile } = useContext(AuthUserContext);
  const navigator = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = React.useState(true)
  const storageRef = firebase.storage().ref();
  const loginPattern = /login/;
  const passResetPattern = /forgot-your-password-step2/;
  const forgetPattern = /reset-password/;
  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

// Get the download URL
    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
        // setImageUrl(url)
        // setLoading(false)
        // Insert url into an <img> tag to "download"
      })
      .catch((error) => {
        reject(error)
        // setLoading(false)

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
  }))
  useEffect(() => {
    setLoading(true)

    // onAuthStateChanged returns an unsubscriber
    const unsubscribeAuth = auth.onAuthStateChanged(async authUser => {
      try {
        const userRef = firebase.firestore().collection('users');
        if (!authUser) {
          setLoading(false)
          if (loginPattern.test(location.pathname) === true) {
            navigator("/auth/login")
          } else {
            // navigator("/auth/select-your-location")
           if(passResetPattern.test(window.location.pathname) === true){
            navigator("/auth/forgot-your-password-step2")
           } else if (forgetPattern.test(window.location.pathname) === true) {
             navigator(window.location.pathname+window.location.search)

           }
           else{
             navigator("/auth/login")

           }

          }
        } else {
          if (authUser && authUser.emailVerified === true) {
            await (authUser ? setUser(authUser) : setUser(null));
            const idToken = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)
            const snapshotUser = await userRef.where('uid', '==', authUser?.uid)
              .get()
              .then()
            if (snapshotUser && snapshotUser.docs.length > 0) {
              console.log( snapshotUser.docs[0]?.data().avatar, 'AVATAR');
              if (snapshotUser.docs[0]?.data().avatar) {
                const avatar = await downloadURL( snapshotUser.docs[0]?.data().avatar);
                setProfile({id: snapshotUser.docs[0].id  ,...snapshotUser.docs[0].data(), avatar, idToken})
              }else {
                setProfile({id: snapshotUser.docs[0].id  ,...snapshotUser.docs[0].data(),  idToken})
              }
              if (location.pathname === '/') {
                navigator(
                  `/${snapshotUser.docs[0].data()?.userType !== 'artist' 
                  ? snapshotUser.docs[0].data()?.userType: 'artists' }/${snapshotUser.docs[0].data()?.userType !== 'admin' ? 'dashboard': 'user-analytics'}`
                );

                /*
                * .data()?.userType === 'creator'
'/creator/dashboard'
'/investor/dashboard'
'/artists/dashboard'
'/admin/user-analytics'
                * */
              }



              setLoading(false)
            }
          } else {
            /*TODO: Your email is not verified*/
            setOpen(true)
          }
        }

      } catch (error) {
        setLoading(false)


      }

    });
    return unsubscribeAuth;
  }, []);
  if (loading) return <Spinner/>;
  return(
    <div className="App">
      {user && !user.emailVerified && profile?.userType !== 'admin' && <Alert severity="warning">Email verification warning: Please verify your account by clicking on the verification link sent to your email address.</Alert>}

      <TopBar showBar={!!user}/>
      { user  && profile ?  profile?.userType === 'creator'?  <CreatorRoutes /> : profile?.userType === 'investor'?  <InvestorRoutes />  : profile?.userType === 'artist'? <ArtistRoutes /> :  <AdminRoutes/>:<AuthRoute />}
      <FooterRoute/>
      <Footer/>
      <Support/>
      <Portal>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" color={'primary'} sx={{textAlign: 'center'}}>
            {"Please confirm your email address"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"  sx={{textAlign: 'center'}}>
              We have send you a confirmation email. You need to confirm your email before moving forward.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant={'contained'} color={'primary'} sx={{px: 5, marginX: 'auto'}} onClick={() => {


              logout().then(() => {
                debugger
                setProfile(null)
                setUser(null)
                setOpen(false)

              })
              navigator('/auth/login');


            }}>Ok</Button>
          </DialogActions>
        </Dialog>
      </Portal>
    </div>
  )
}

const AuthRoute = () => {
  return(
    <Routes>
      <Route  path=''/>
      <Route  path='auth'   element={<Auth/>}>
        <Route  path={''} element={<Home/>}/>
        <Route  path={'login'}  element={<Login/>}/>
        <Route  path={'who-are-you'}   element={<WhoAreYou/>}/>
        <Route  path={'forgot-your-password-step1'} element={<ForgotYourPasswordStep1/>}/>
        <Route  path='reset-password' element={<ResetPassword/>}/>
        <Route  path='forgot-your-password-step2' element={<ForgotYourPasswordStep2/>}/>
        <Route  path={'join-us'}  element={<JoinUs/>}/>
        <Route  path={'additional-details'}  element={<AdditionalDetailsComponent/>}/>
        <Route  path={'about-your-work'}  element={<AboutYourWorkComponent/>}/>
        <Route  path={'select-your-location'}  element={<SelectYourLocation/>}/>
        {/*<Route  path={'forgot-your-password-step1'}  element={<ForgotYourPasswordStep1/>}/>*/}
        {/*<Route  path={'forgot-your-password-step2'}  element={<ForgotYourPasswordStep2/>}/>*/}

      </Route>
    </Routes>

  )
}
const FooterRoute = () => {
  return(
    <Routes>
      <Route  path=''/>
      <Route path={'privacy'} element={<Privacy/>}></Route><Route/>
      <Route path={'terms'} element={<Terms/>}></Route><Route/>
      <Route path={'cookies'} element={<Cookies/>}></Route><Route/>
      <Route path={'contactus'} element={<Contact/>}></Route><Route/>


    </Routes>

  )
}


function Home() {
  const navigate = useNavigate();
  return(
    <header className="App-header">
      <img src={logo} className="App-logo" alt="logo" />
      <p>
        Edit <code>src/App.js</code> and save to reload.
      </p>
      <Button
        onClick={() => navigate('/auth/join-us')}
      >
        Join us
      </Button>
    </header>
  );
}
function Auth() {
  return (<Outlet/>)
}

function CreateProject() {
  return (<h1>{'Create a project'}</h1>)
}

